






import { Component, Vue } from 'vue-property-decorator';
import ossLicense from '@/../ossLicense';
import { refreshStores } from '@/containers/globals/globalSharedService';
import { commonModule } from '@/store/modules/CommonStore';
import { LoginInfo } from '@/types/type';

@Component({})
export default class OssLicense extends Vue {
  private ossLicense = ossLicense;

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    await refreshStores(loginInfo);
  }
}
